"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TwitterXShareMenuItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TwitterX = _interopRequireDefault(require("@kyruus/react-ikons/TwitterX"));
var _style = require("./style");
const shareUrl = (url, text) => {
  return `https://twitter.com/intent/tweet/?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
};
const TwitterXShareButton = _ref => {
  let {
    url,
    text,
    onBeforeClick,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_style.StyledIconLink, (0, _extends2.default)({}, props, {
    href: shareUrl(url, text),
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onBeforeClick
  }), /*#__PURE__*/_react.default.createElement(_TwitterX.default, {
    size: _style.ICON_HEIGHT,
    "aria-hidden": "true",
    title: "",
    "data-testid": "twitterX-svg"
  }));
};
const TwitterXShareMenuItem = _ref2 => {
  let {
    url,
    text,
    showLabel,
    label,
    onClick,
    ...props
  } = _ref2;
  const handleClick = (url, text) => {
    const targetUrl = shareUrl(url, text);
    if (onClick) {
      onClick('twitter');
    }
    // check for window in case this is ever server-side-rendered
    if (typeof window !== 'undefined') {
      window.open(targetUrl);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_style.StyledMenuItem, (0, _extends2.default)({}, props, {
    onClick: () => {
      handleClick(url, text);
    }
  }), /*#__PURE__*/_react.default.createElement(_TwitterX.default, {
    size: _style.ICON_HEIGHT,
    "aria-hidden": "true",
    title: "",
    "data-testid": "twitterX-svg"
  }), showLabel ? /*#__PURE__*/_react.default.createElement(_style.StyledLabel, null, label) : null);
};
exports.TwitterXShareMenuItem = TwitterXShareMenuItem;
TwitterXShareButton.propTypes = {
  /**
   * The url of the page you want to share.
   */
  url: _propTypes.default.string.isRequired,
  /**
   * The text that will form the tweet with the url.
   */
  text: _propTypes.default.string.isRequired,
  /**
   * Called before the the onClick is executed for the link.
   */
  onBeforeClick: _propTypes.default.func
};
TwitterXShareMenuItem.propTypes = {
  /**
   * The url of the page you want to share.
   */
  url: _propTypes.default.string.isRequired,
  /**
   * The text that will form the post.
   */
  text: _propTypes.default.string.isRequired,
  /**
   * Whether to show the 'X' label or not
   */
  showLabel: _propTypes.default.bool,
  /**
   * Label content
   */
  label: _propTypes.default.node,
  /**
   * Called before the the onClick is executed for the link.
   */
  onClick: _propTypes.default.func
};
var _default = exports.default = TwitterXShareButton;
TwitterXShareMenuItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TwitterXShareMenuItem",
  "props": {
    "url": {
      "description": "The url of the page you want to share.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "text": {
      "description": "The text that will form the post.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "showLabel": {
      "description": "Whether to show the 'X' label or not",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "description": "Label content",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onClick": {
      "description": "Called before the the onClick is executed for the link.",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};
TwitterXShareButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TwitterXShareButton",
  "props": {
    "url": {
      "description": "The url of the page you want to share.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "text": {
      "description": "The text that will form the tweet with the url.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onBeforeClick": {
      "description": "Called before the the onClick is executed for the link.",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};